import * as React from 'react'

import {t, validateEmail} from '@lib/helpers'
import {useAsync} from '@lib/hooks'
import {sendEmail} from '@lib/services'
import {useUTMContext} from '@lib/gtm'

const Contact = ({children}) => {
  const {run: runSendEmail, isLoading, isSuccess} = useAsync(sendEmail)
  const ref = React.useRef()

  const {data: utm} = useUTMContext()

  React.useEffect(() => {
    if (isSuccess && ref.current) {
      ref.current.reset()
    }
  }, [isSuccess])

  const handleSubmit = async (e) => {
    e.preventDefault()

    const {name, email, phone} = e.target.elements

    const emailData = {
      to: process.env.SALES_EMAIL,
      subject: `[${window.location.host}] ${email.value} wants to contact with you`,
      message: `
        Name: ${name.value}
        Email: ${email.value}
        Tel: ${phone.value}
      )}`,
    }

    const reqBody = {
      email: email.value,
      name: name.value,
      phone: phone.value,
      url: window.location.href,
    }

    runSendEmail({
      emailData: {...emailData, path: process.env.EMAIL_API_URL},
      reqBody: reqBody,
      utm,
    })
  }

  return (
    <section className='DemoDetail__contact'>
      <div className='container' id='contact'>
        {children}

        <p className='DemoDetail__contact__p'>
          {t('pages.demo.contact.message')}{' '}
          <strong>
            <a href='mailto:sales@datawow.io'>sales@datawow.io</a>
          </strong>{' '}
          {t('pages.demo.contact.or')}{' '}
          <strong>
            <a href='tel:020245560'>02-024-5560</a>
          </strong>
        </p>

        <form ref={ref} onSubmit={handleSubmit}>
          <input
            type='text'
            name='name'
            placeholder={t('pages.demo.contact.form.name')}
            required
          />
          <input
            type='email'
            name='email'
            onBlur={validateEmail}
            placeholder={t('pages.demo.contact.form.email')}
            required
          />
          <input
            type='tel'
            name='phone'
            pattern='\d{10}'
            title='Please enter a 10-digit phone number'
            placeholder={`${t('pages.demo.contact.form.phone')}`}
            required
          />

          <button className='DemoDetail__button' disabled={isLoading}>
            {isSuccess
              ? t('layout.GetStarted.form.sent')
              : isLoading
              ? t('layout.loading')
              : t('pages.demo.contact.form.submit')}
          </button>
        </form>

        <div className='DemoDetail__contact__info'>
          <address
            dangerouslySetInnerHTML={{__html: t('pages.demo.contact.address')}}
          />

          <p>
            {t('pages.demo.contact.email')}:{' '}
            <a href='mailto:sales@datawow.io'>sales@datawow.io</a>
            <br />
            {t('pages.demo.contact.tel')}:{' '}
            <a href='tel:020245560'>02-024-5560</a>
          </p>
        </div>

        <nav className='DemoDetail__socials'>
          <a
            href='https://www.facebook.com/datawowai/'
            target='_blank'
            rel='nofollow noopener noreferrer'
            title='Facebook'
          >
            <img src='/images/demo/icon-facebook.svg' alt='Facebook' />
          </a>
          <a
            href='https://www.linkedin.com/company/datawowio/'
            target='_blank'
            rel='nofollow noopener noreferrer'
            title='Linkedin'
          >
            <img src='/images/demo/icon-linkedin.svg' alt='Linkedin' />
          </a>

          <a href='/blogs' title='DataWow Blog'>
            <img src='/images/demo/icon-blog.svg' alt='Blog' />
          </a>
        </nav>
      </div>
    </section>
  )
}

export default Contact
